import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-locale", "data-template-id", "data-businessunit-id", "data-style-height", "data-style-width", "data-theme", "data-stars"]
const _hoisted_2 = ["href", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_script_loader = _resolveComponent("script-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: "trustpilot-widget",
    "data-locale": _ctx.local,
    "data-template-id": _ctx.templateId,
    "data-businessunit-id": _ctx.businessunitId,
    "data-style-height": _ctx.height,
    "data-style-width": _ctx.width,
    "data-theme": _ctx.theme,
    "data-stars": _ctx.stars
  }, [
    _createElementVNode("a", {
      href: _ctx.linkUrl,
      target: "_blank",
      rel: "noopener",
      textContent: _toDisplayString(_ctx.linkText)
    }, null, 8 /* PROPS */, _hoisted_2),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_ctx.loadTrustpilot)
      ? (_openBlock(), _createBlock(_component_script_loader, {
          key: 0,
          src: _ctx.jsUrl
        }, null, 8 /* PROPS */, ["src"]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}